export const ROUTES = {
    HOME: '/',
    SEARCH: '/search',
    LIST_FORUMS: '/list-forums',
    FORUM_TOPICS: '/list-topics/:forumId',
    TOPIC_SETS: '/show-topic/:topicId',
    POST: '/show-post/:postId'
  }